import React from 'react';
import PropTypes from 'prop-types';
import styles from '../HistoricalDashboardPage/HistoricalDashboardPage.module.scss';
import { HistoricDataGrid } from '../../components/HistoricDataGrid';
import { ECN_TRADE_SYMBOL_SUMMARY, ECN_TRADE_MMID_SUMMARY,
  ECN_ORDER_SYMBOL_SUMMARY, ECN_ORDER_MMID_SUMMARY, ECN_OPEN_ORDER_SYMBOL_SUMMARY, ECN_OPEN_ORDER_MMID_SUMMARY,
  ECN_UNENTITLED_SYMBOLS_SUMMARY, ECN_ORDER_TRADE_RATIO_SUMMARY
} from '../../util/dashBoardPageConstants';
import getConfig from '../../config';
const { DASHBOARD_CONFIG } = getConfig();
const ECN_TRADE_SYMBOL_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(ECN_TRADE_SYMBOL_SUMMARY);
const ECN_TRADE_MMID_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(ECN_TRADE_MMID_SUMMARY);

const ECN_ORDER_SYMBOL_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(ECN_ORDER_SYMBOL_SUMMARY);
const ECN_ORDER_MMID_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(ECN_ORDER_MMID_SUMMARY);
const ECN_UNENTITLED_SYMBOLS_CONFIG = DASHBOARD_CONFIG.get(ECN_UNENTITLED_SYMBOLS_SUMMARY);
const ECN_ORDER_TRADE_RATIO_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(ECN_ORDER_TRADE_RATIO_SUMMARY);

const ECN_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(ECN_OPEN_ORDER_SYMBOL_SUMMARY);
const ECN_OPEN_ORDER_MMID_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(ECN_OPEN_ORDER_MMID_SUMMARY);

class HistoricalDashboardEcnGrids extends React.PureComponent {
  render () {
    const historicDateFormat = this.props.historicDateFormat;
    return (
      <div className={styles.ecnTables} >

        <HistoricDataGrid
          key={ECN_TRADE_SYMBOL_SUMMARY_CONFIG.identifier}
          identifier={ECN_TRADE_SYMBOL_SUMMARY_CONFIG.identifier}
          header={ECN_TRADE_SYMBOL_SUMMARY_CONFIG.header}
          api={ECN_TRADE_SYMBOL_SUMMARY_CONFIG.historicApi}
          downloadApi={ECN_TRADE_SYMBOL_SUMMARY_CONFIG.downloadApi}
          historicDate={historicDateFormat}
          lastUpdatedField={ECN_TRADE_SYMBOL_SUMMARY_CONFIG.lastUpdatedField}
          totalField={ECN_TRADE_SYMBOL_SUMMARY_CONFIG.totalField}
          columns={ECN_TRADE_SYMBOL_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={ECN_TRADE_SYMBOL_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={ECN_TRADE_SYMBOL_SUMMARY_CONFIG.summaryGroupDataColumn}
          maxRows={20} />

        <HistoricDataGrid
          key={ECN_TRADE_MMID_SUMMARY_CONFIG.identifier}
          identifier={ECN_TRADE_MMID_SUMMARY_CONFIG.identifier}
          header={ECN_TRADE_MMID_SUMMARY_CONFIG.header}
          api={ECN_TRADE_MMID_SUMMARY_CONFIG.historicApi}
          downloadApi={ECN_TRADE_MMID_SUMMARY_CONFIG.downloadApi}
          historicDate={historicDateFormat}
          lastUpdatedField={ECN_TRADE_MMID_SUMMARY_CONFIG.lastUpdatedField}
          totalField={ECN_TRADE_MMID_SUMMARY_CONFIG.totalField}
          columns={ECN_TRADE_MMID_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={ECN_TRADE_MMID_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={ECN_TRADE_MMID_SUMMARY_CONFIG.summaryGroupDataColumn}
          maxRows={20} />

        <HistoricDataGrid
          key={ECN_ORDER_SYMBOL_SUMMARY_CONFIG.identifier}
          identifier={ECN_ORDER_SYMBOL_SUMMARY_CONFIG.identifier}
          header={ECN_ORDER_SYMBOL_SUMMARY_CONFIG.header}
          api={ECN_ORDER_SYMBOL_SUMMARY_CONFIG.historicApi}
          downloadApi={ECN_ORDER_SYMBOL_SUMMARY_CONFIG.downloadApi}
          historicDate={historicDateFormat}
          lastUpdatedField={ECN_ORDER_SYMBOL_SUMMARY_CONFIG.lastUpdatedField}
          totalField={ECN_ORDER_SYMBOL_SUMMARY_CONFIG.totalField}
          columns={ECN_ORDER_SYMBOL_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={ECN_ORDER_SYMBOL_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={ECN_ORDER_SYMBOL_SUMMARY_CONFIG.summaryGroupDataColumn}
          maxRows={20}
        />

        <HistoricDataGrid
          ket={ECN_ORDER_MMID_SUMMARY_CONFIG.identifier}
          identifier={ECN_ORDER_MMID_SUMMARY_CONFIG.identifier}
          header={ECN_ORDER_MMID_SUMMARY_CONFIG.header}
          api={ECN_ORDER_MMID_SUMMARY_CONFIG.historicApi}
          downloadApi={ECN_ORDER_MMID_SUMMARY_CONFIG.downloadApi}
          historicDate={historicDateFormat}
          lastUpdatedField={ECN_ORDER_MMID_SUMMARY_CONFIG.lastUpdatedField}
          totalField={ECN_ORDER_MMID_SUMMARY_CONFIG.totalField}
          columns={ECN_ORDER_MMID_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={ECN_ORDER_MMID_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={ECN_ORDER_MMID_SUMMARY_CONFIG.summaryGroupDataColumn}
          maxRows={20}
        />

        <HistoricDataGrid
          key={ECN_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG.identifier}
          identifier={ECN_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG.identifier}
          header={ECN_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG.header}
          api={ECN_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG.historicApi}
          downloadApi={ECN_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG.downloadApi}
          historicDate={historicDateFormat}
          lastUpdatedField={ECN_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG.lastUpdatedField}
          totalField={ECN_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG.totalField}
          columns={ECN_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={ECN_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={ECN_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG.summaryGroupDataColumn}
          maxRows={20}
        />

        <HistoricDataGrid
          key={ECN_OPEN_ORDER_MMID_SUMMARY_CONFIG.identifier}
          identifier={ECN_OPEN_ORDER_MMID_SUMMARY_CONFIG.identifier}
          header={ECN_OPEN_ORDER_MMID_SUMMARY_CONFIG.header}
          api={ECN_OPEN_ORDER_MMID_SUMMARY_CONFIG.historicApi}
          downloadApi={ECN_OPEN_ORDER_MMID_SUMMARY_CONFIG.downloadApi}
          historicDate={historicDateFormat}
          lastUpdatedField={ECN_OPEN_ORDER_MMID_SUMMARY_CONFIG.lastUpdatedField}
          totalField={ECN_OPEN_ORDER_MMID_SUMMARY_CONFIG.totalField}
          columns={ECN_OPEN_ORDER_MMID_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={ECN_OPEN_ORDER_MMID_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={ECN_OPEN_ORDER_MMID_SUMMARY_CONFIG.summaryGroupDataColumn}
          maxRows={20}
        />

        <HistoricDataGrid
          key={ECN_ORDER_TRADE_RATIO_SUMMARY_CONFIG.identifier}
          identifier={ECN_ORDER_TRADE_RATIO_SUMMARY_CONFIG.identifier}
          header={ECN_ORDER_TRADE_RATIO_SUMMARY_CONFIG.header}
          api={ECN_ORDER_TRADE_RATIO_SUMMARY_CONFIG.historicApi}
          downloadApi={ECN_ORDER_TRADE_RATIO_SUMMARY_CONFIG.downloadApi}
          historicDate={historicDateFormat}
          lastUpdatedField={ECN_ORDER_TRADE_RATIO_SUMMARY_CONFIG.lastUpdatedField}
          columns={ECN_ORDER_TRADE_RATIO_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={ECN_ORDER_TRADE_RATIO_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={ECN_ORDER_TRADE_RATIO_SUMMARY_CONFIG.summaryGroupDataColumn}
          maxRows={20}
        />
        <HistoricDataGrid
          key={ECN_UNENTITLED_SYMBOLS_CONFIG.identifier}
          identifier={ECN_UNENTITLED_SYMBOLS_CONFIG.identifier}
          header={ECN_UNENTITLED_SYMBOLS_CONFIG.header}
          api={ECN_UNENTITLED_SYMBOLS_CONFIG.historicApi}
          downloadApi={ECN_UNENTITLED_SYMBOLS_CONFIG.downloadApi}
          historicDate={historicDateFormat}
          lastUpdatedField={ECN_UNENTITLED_SYMBOLS_CONFIG.lastUpdatedField}
          totalField={ECN_UNENTITLED_SYMBOLS_CONFIG.totalField}
          columns={ECN_UNENTITLED_SYMBOLS_CONFIG.columns}
          summaryGroupTitleColumn={ECN_UNENTITLED_SYMBOLS_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={ECN_UNENTITLED_SYMBOLS_CONFIG.summaryGroupDataColumn}
          maxRows={20}
        />

      </div>
    );
  }
}

export default HistoricalDashboardEcnGrids;
export const MemoizedHistoricalDashboardEcnGrids = React.memo(HistoricalDashboardEcnGrids);

HistoricalDashboardEcnGrids.propTypes = {
  historicDateFormat: PropTypes.string
};
